module.exports = __webpack_public_path__ + "static/media/FullScreenIcon.fd22a76b.svg";